var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.0966797C13.9625 0.0966797 13 0.938604 13 1.78053H6C6 0.938604 5.0375 0.0966797 4.25 0.0966797H0.75V7.674C0.75 8.51593 1.625 9.35785 2.5 9.35785H4.425C4.775 11.0417 5.9125 12.473 8.625 12.7255V14.4768C6 14.864 6 16.9352 6 16.9352H13C13 16.9352 13 14.864 10.375 14.4768V12.7255C13.0875 12.473 14.225 11.0417 14.575 9.35785H16.5C17.375 9.35785 18.25 8.51593 18.25 7.674V0.0966797H14.75ZM4.25 7.674H2.5V1.78053H4.25V7.674ZM13 8.09496C13 9.71988 12.4925 11.0417 9.5 11.0417C6.51625 11.0417 6 9.71988 6 8.09496V3.46438H13V8.09496ZM16.5 7.674H14.75V1.78053H16.5V7.674Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwards);
export default __webpack_public_path__ + "static/media/awards.aeaf6224.svg";
export { ForwardRef as ReactComponent };